import "@/app/pages/utilityPages/OptoutcontactsDetails/OptoutcontactsStyles.scss";
import $ from "jquery";
import { dnbComLog, isNotUndefined, LogSeverity } from "@/shared/FunctionCore";

export const optoutcontactsDetails = (optoutcontactsParameter: any): void => {
  const $optoutcontactsWrapper = $(".optoutcontactsWrapper");

  const $exportButton = $optoutcontactsWrapper.find(".exportButton");
  const $requestTypeExportFilter = $optoutcontactsWrapper.find(
    ".requestTypeExportFilter"
  );
  const $timePeriodFromExportFilter = $optoutcontactsWrapper.find(
    ".timePeriodFromExportFilter"
  );
  const $timePeriodToExportFilter = $optoutcontactsWrapper.find(
    ".timePeriodToExportFilter"
  );

  const handleExportClick = () => {
    const getFormattedDateString = (dateToParse: string[] | number | string) => {
      if (typeof dateToParse !== "number" && typeof dateToParse !== "string") {
        dnbComLog(LogSeverity.ERROR, 'Invalid date format ');
      }

      const date = new window.Date(dateToParse);

      return `${window.String(date.getMonth() + 1).padStart(2, "0")}/${window
        .String(date.getDate())
        .padStart(2, "0")}/${date.getFullYear()}`;
    };

    const matchCriteria = (contact: any) => {
      const timePeriodFromExportFilterValue = $timePeriodFromExportFilter.val();
      if (isNotUndefined(timePeriodFromExportFilterValue)) {
        const timePeriodFromExportFilterValueString = getFormattedDateString(
          timePeriodFromExportFilterValue
        );
        const result =
          new window.Date(timePeriodFromExportFilterValueString).getTime() <=
          new Date(contact.submitDt).getTime();

        if (!result) {
          return false;
        }
      }

      const timePeriodToExportFilterValue = $timePeriodToExportFilter.val();

      if (isNotUndefined(timePeriodToExportFilterValue)) {
        const timePeriodToExportFilterValueString = getFormattedDateString(
          timePeriodToExportFilterValue
        );

        const result =
          new window.Date(contact.submitDt).getTime() <=
          new Date(timePeriodToExportFilterValueString).getTime();

        if (!result) {
          return false;
        }
      }

      const requestTypeExportFilterValue = $requestTypeExportFilter.val();

      if (isNotUndefined(requestTypeExportFilterValue)) {
        let arrayToUse: number[] | string[];

        if (typeof requestTypeExportFilterValue === "string") {
          arrayToUse = [requestTypeExportFilterValue];
        } else if (typeof requestTypeExportFilterValue === "number") {
          arrayToUse = [requestTypeExportFilterValue];
        } else {
          arrayToUse = requestTypeExportFilterValue;
        }

        const getRequestTypeExists = () => {
          if (arrayToUse.length === 0) {
            return true;
          }

          for (const arrayToUseElement of arrayToUse) {
            if (arrayToUseElement === contact.requestType) {
              return true;
            }
          }

          return false;
        };

        const result = getRequestTypeExists();

        if (!result) {
          return false;
        }
      }

      return true;
    };
    // match crtiteria ends here

    let counter = 0;

    let html =
      "<table><thead><tr><th>Count</th><th>First Name</th><th>Last Name</th><th>Contact URL</th><th>Contact ID</th><th>Expiration Date</th><th>Requestor</th><th>Submit Date</th><th>Request Type</th></tr></thead><tbody>";

    const optoutContacts = optoutcontactsParameter.optoutContacts;

    if (isNotUndefined(optoutContacts) && optoutContacts !== null) {
      for (const contact of optoutContacts) {
        const matchCriteriaResult = matchCriteria(contact);
        if (matchCriteriaResult) {
          counter += 1;

          html = `${html}<tr>`;
          html = `${html}<td>${counter}</td>`;
          html = `${html}<td>${contact.givenName}</td>`;
          html = `${html}<td>${contact.lastName}</td>`;
          html = `${html}<td>${contact.contactUrl}</td>`;
          html = `${html}<td>${contact.contactId}</td>`;
          html = `${html}<td>${
            isNotUndefined(contact.expirationDt) &&
            contact.expirationDate !== null
              ? window.String(contact.expirationDt)
              : ""
          }</td>`;
          html = `${html}<td>${contact.requestor}</td>`;
          html = `${html}<td>${contact.submitDt}</td>`;
          html = `${html}<td>${contact.requestType}</td>`;
          html = `${html}</tr>`;
        }
      }
    }

    html = `${html}</tbody></table>`;

    const excelDocument = `
  <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
      <head>
          <!--[if gte mso 9]>
              <xml>
                  <x:ExcelWorkbook>
                      <x:ExcelWorksheets>
                          <x:ExcelWorksheet>
                              <x:Name>Worksheet</x:Name>
                              <x:WorksheetOptions>
                                  <x:DisplayGridlines/>
                              </x:WorksheetOptions>
                          </x:ExcelWorksheet>
                      </x:ExcelWorksheets>
                  </x:ExcelWorkbook>
              </xml>
          <![endif]-->
      </head>

      <body>
          <table>
              ${html}
          </table>
      </body>
  </html>`;

    const excelDocumentBaseSixtyFourEncoded = window.btoa(
      window.unescape(window.encodeURIComponent(excelDocument))
    );

    const link = window.document.createElement("a");
    link.download = "Contact-Optout-Details.xls";
    link.href = `data:application/vnd.ms-excel;base64,${excelDocumentBaseSixtyFourEncoded}`;

    link.click();
  };

  // First, remove any previous click event to avoid duplicates
  $exportButton.off("click");

  // Add the click event
  $exportButton.on("click", handleExportClick);
};
